<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
                Hammaddeler <button class="btn btn-primary" (click)="openSaveModal()">+ Yeni Ekle</button>
              </ng-container>
              <ng-container mCardBody>
                <div class="row mb-2">
                 
                  <div class="col-md-12">
                    Hammadde Arama   <input type="text" class="form-control col-md-4" [(ngModel)]="arama" (change)="search($event)">
                  </div>
                </div>
                <div class="table-responsive">
               
                <table class="table table-bordered">
                  <thead>
                  <tr>
                   
                    <th>INCI Adı</th>
                    <th>CAS</th>
                    <th>EINECS/ELICS</th>
                    <th>Fonksiyon</th>
                    <th>Annex</th>
                    <th>Maks. Kons.</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let h of filteredhammeddeler">
                   
                    <td>{{h.inciName}}</td>
                    <td>{{h.cas}}</td>
                    <td>{{h.einecs}}</td>
                    <td>{{h.function}}</td>
                    <td>{{h.annex}}</td>
                    <td>{{h.maxConsantrasyon}}</td>
                    <td>
                      <i class="la la-edit success" (click)="openEditModal(h)" style="cursor: pointer;"></i> |
                      <i class="la la-remove danger" (click)="delete(h.id)" style="cursor: pointer;"></i>
                    </td>
                  </tr>
                </tbody>
                 <tfoot>
                  <tr>
                    <td colspan="7">
                      <button class="btn btn-primary" (click)="prevPage()"><</button>
                      <span class="btn btn-primary" >{{page}}</span>
                      <button class="btn btn-primary" (click)="nextPage()">></button>
                    </td>
                  </tr>
                </tfoot>
                </table>
                </div>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
